

const shuffleArr = (arr: any[]) => [...arr].sort(() => .5 - Math.random())


export default shuffleArr